import { render } from "./ReportVersion8_0.vue?vue&type=template&id=5546dff2&scoped=true&ts=true"
import script from "./ReportVersion8_0.vue?vue&type=script&lang=ts"
export * from "./ReportVersion8_0.vue?vue&type=script&lang=ts"

import "./ReportVersion8_0.vue?vue&type=style&index=0&id=5546dff2&scoped=true&lang=stylus"

import exportComponent from "D:\\zhongzhi\\wuzangceping_sahngyeban\\health-WeChat-small-program-page\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5546dff2"]])

export default __exports__